function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import DefaultBlueButton from "../../../Misc/Buttons/DefaultBlueButton";
import ConfirmModal from "./ConfirmModal";

var RecordedVideoPan = function (_React$Component) {
  _inherits(RecordedVideoPan, _React$Component);

  function RecordedVideoPan() {
    var _temp, _this, _ret;

    _classCallCheck(this, RecordedVideoPan);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      modalActive: false
    }, _this.toggleModal = function () {
      return _this.setState({
        modalActive: !_this.state.modalActive
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  RecordedVideoPan.prototype.render = function render() {
    var _props = this.props,
        confirm = _props.confirm,
        discard = _props.discard;
    var modalActive = this.state.modalActive;
    return React.createElement(React.Fragment, null, React.createElement(ConfirmModal, {
      active: modalActive,
      onClose: this.toggleModal,
      onConfirm: discard
    }), React.createElement("div", {
      className: "recorder__toolbar-preview-info"
    }, "Preview your recording, if all looks good you\u2019re ready to go!"), React.createElement("div", {
      className: "recorder__toolbar-preview-buttons"
    }, React.createElement(DefaultBlueButton, {
      size: "s",
      onClick: confirm
    }, "Use this video"), React.createElement("button", {
      className: "button button--reset button--link",
      onClick: this.toggleModal
    }, "Discard video and start over")));
  };

  return RecordedVideoPan;
}(React.Component);

RecordedVideoPan.propTypes = process.env.NODE_ENV !== "production" ? {
  confirm: PropTypes.func.isRequired,
  discard: PropTypes.func.isRequired
} : {};
export default RecordedVideoPan;